var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { formatCompactNumber } from "shared/lib/format";
export var MaxButton = memo(function MaxButton(_a) {
    var value = _a.value, onClick = _a.onClick, _b = _a.sx, sx = _b === void 0 ? {} : _b;
    var t = useTranslation().t;
    return (_jsx(Box, { sx: { display: "flex", justifyContent: "flex-end", mt: 0.1 }, children: _jsxs(Button, { type: "button", onClick: function () { return onClick(String(value)); }, sx: __assign({ background: "transparent", border: "none", color: "#909090", fontSize: 11, cursor: "pointer", padding: 0, textTransform: "none" }, sx), children: [t("buttons.max"), " ", formatCompactNumber(Number(value))] }) }));
});
